import { render } from "./SliderArticle.vue?vue&type=template&id=2cf9162b"
import script from "./SliderArticle.vue?vue&type=script&lang=js"
export * from "./SliderArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__